import { useState, useCallback } from "react";

// * Icons
import clock from "./assets/clock.svg";
import transcodeImg from  "../../../src/components/Actions/img/transcode.svg";
import desctopImg from "../../../src/components/Actions/img/desktop.svg";

// * Components
import Layout from "../../components/Layout";
import { Actions } from "../../components/Actions";
import { Broadcasts } from "../../components/Broadcasts";
import { Greeting } from "../../components/Greeting";
import GreetingImage from "../../components/Greeting/GreetingImage";
import { CreateBroadcastPopup } from "../../components/CreateBroadcastPopup";
import { StartBroadcasting } from "../../components/StartBroadcasting";
import { ButtonWithImage } from "../../components/ButtonWithImage";
import TranscodePresetsPopup from "../../components/TranscodePresetsPopup";

// * Styles
import s from "./Dashboard.module.css";

// * Hooks
import { useScreenWidth } from "../../hooks/useScreenWidth";
import { useGetUserQuery } from "../../features/api/apiSlice";
import { useNavigate } from "react-router-dom";

// * Helpers
import classNames from "classnames";

export function Dashboard() {
    const { isMobile } = useScreenWidth();
    const { data: user } = useGetUserQuery();
    const navigate = useNavigate();
    const [isStartBroadcastingError, setIsStartBroadcastingError] = useState(false);
    const [isShowCreateBroadcastPopup, setIsShowCreateBroadcastPopup] = useState(false);
    const [isOpenTranscodePresetPopup, setIsOpenTranscodePresetPopup] = useState(false);
    const handleStartBroadcastingError = useCallback((error: string) => setIsStartBroadcastingError(Boolean(error)), []);
    const handleCreateBroadcast = useCallback(() => setIsShowCreateBroadcastPopup(true), []);

    const handleOpenTranscodePresetPopup = () => {
        if (!user?.tariff.max_active_transcodes) {
            navigate('/tariffs');
        }

        setIsOpenTranscodePresetPopup(true);
    };

    const handleOpenStudio = () => {
        if (user?.tariff.name === "R2" && !user?.studio_support) {
            navigate('/tariffs');
        } else {
            navigate('/studio');
        }
    };

    return (
        <Layout isBackBtn={false}>
            <div className={classNames(
                s['dashboard'],
                { [s['dashboard_broadcasting-error']]: isStartBroadcastingError }
            )}
            >
                {isMobile && <GreetingImage />}

                <Greeting />
                <StartBroadcasting onError={handleStartBroadcastingError} />

                {isMobile &&
                    <>
                        <ButtonWithImage
                            className={s["stream-planning"]}
                            imgSrc={clock}
                            text="Запланировать эфир"
                            onClick={() => setIsShowCreateBroadcastPopup(true)}
                        />
                        <ButtonWithImage
                            imgSrc={transcodeImg}
                            alt="Transcoding"
                            text="Транскодинг"
                            className={s["stream-planning"]}
                            onClick={handleOpenTranscodePresetPopup}
                        />
                        <ButtonWithImage
                            imgSrc={desctopImg}
                            alt="Studio"
                            text="Студия Restream"
                            className={s["stream-planning"]}
                            onClick={handleOpenStudio}
                        />
                    </>
                }

                {!isMobile && <Broadcasts onCreateBroadcast={handleCreateBroadcast} />}
                {!isMobile &&
                    <Actions
                        user={user}
                        className={s['dashboard__actions']}
                        onCreateBroadcast={handleCreateBroadcast}
                        onOpenTranscodePresetPopup={handleOpenTranscodePresetPopup}
                        onOpenStudio={handleOpenStudio}
                    />
                }

            </div>

            {isShowCreateBroadcastPopup && (
                <CreateBroadcastPopup onClose={() => setIsShowCreateBroadcastPopup(false)} />
            )}

            {isOpenTranscodePresetPopup &&
                <TranscodePresetsPopup
                    onClose={() => setIsOpenTranscodePresetPopup(false)}
                    isShow={isOpenTranscodePresetPopup}
                    maxWidth="1000px"
                />
            }
        </Layout>
    );
}